<template>
 <khrc-navbar/>
  <clinical-lab-detail-component />
</template>

<script>
import KhrcNavbar from "@/components/KhrcNavbar.vue";
import ClinicalLabDetailComponent from "@/components/ClinicalLabDetailComponent";
export default {
  components: {
    KhrcNavbar,
    ClinicalLabDetailComponent,
  },
};
</script>

<style></style>
